import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './AttachFileButton.css';

type TAttachFileButtonProps = {
  isDisabled: boolean;
  onClick(): void;
};

export const AttachFileButton: React.VFC<TAttachFileButtonProps> = ({ isDisabled, onClick }) => {
  return (
    <button className={styles['attach_button']} onClick={onClick} disabled={isDisabled} data-name="AttachFileButton">
      <IconActionPlus16 />
    </button>
  );
};
